import React from 'react'
import './Item.css'
import {Link} from 'react-router-dom'

const Item = (props) => {
  return (
    <div className='item' >
      <Link to={`/product/${props.id}`} ><div className='item-img' ><img src={props.image} alt="" /></div></Link> 
        <p className='item-name' >{props.name}</p>
        <span className='price' >₹{props.price}</span>
    </div>
  )
}

export default Item